import { ContainerComponent, wrap } from 'AppReact';
import { SecondaryTextXlBold, Icon, SecondaryTextXs } from "atoms";
import {
  FlexBoxWrapper, CustomBackgroundWrapper, GenericWrapper,
  Mr3, Mt2, SavedReportCardWrapper, Mr4, FlexCenterWrapper,
  FullWidthFlexBoxJustifyCenterWrapper
} from 'wrappers';
import { OutlinedButton, SolidButton } from 'molecules';
import controller from './controller';
import internalState from './internalState';

export const definition = {
  name: 'SavedReportCard',
  controller: controller,
  initialProps: ({ report, icon }) => ({ report, icon }),
  props: internalState,
  elements: [
    {
      wrapper: FlexBoxWrapper,
      name: 'MainWrapper',
      elements: [
        {
          wrapper: Mr3,
          name: 'MarginRight',
          elements: [
            {
              wrapper: CustomBackgroundWrapper,
              name: 'IconWrapper',
              renderIf: ({ icon }) => !!icon,
              displayState: ({ }) => ({
                height: '57px', width: '57px',
                justifyContent: 'center',
                alignItems: 'center',
                background: `${window?.settings?.primary_color ?? '#1DBD6B'}1A`,
                borderRadius: '14px',
              }),
              elements: [
                {
                  component: Icon,
                  name: 'Icon',
                  displayValue: ({ icon }) => icon,
                }
              ]
            },
          ]
        },
        {
          wrapper: GenericWrapper,
          name: 'Text',
          elements: [
            {
              component: SecondaryTextXlBold,
              name: 'Title',
              displayValue: ({ report }) => report.displayName || '',
            },
            {
              component: wrap(SecondaryTextXs, Mt2),
              name: 'Description',
              displayValue: ({ report }) => report.description || '',
            }
          ]
        }
      ]
    },
    {
      wrapper: FullWidthFlexBoxJustifyCenterWrapper,
      name: 'ButtonsWrapper',
      elements: [
        {
          component: wrap(wrap(OutlinedButton, Mr4), FlexCenterWrapper),
          name: 'ViewAll',
          bindings: ({ }) => ({ title: 'View All Reports', big: true }),
          displayState: ({ }) => ({ big: true }),
        },
        {
          component: wrap(SolidButton, FlexCenterWrapper),
          name: 'CreateNew',
          bindings: ({ }) => ({ title: 'Create New', big: true }),
          displayState: ({ }) => ({ big: true }),
        }
      ]
    }
  ],
};

export default wrap(ContainerComponent(definition), SavedReportCardWrapper);
